import * as React from 'react';

import SearchResultHeader from '../../../shared/scene_form/SearchResultHeader';
import TotalCountWithSort from './TotalCountWithSort';
import ListItemNormalSeparator from '../../../shared/lists/separators/ListItemNormalSeparator';

interface Props {
  title: string;
  totalCount: number;
  sort?: 'post_updated_at' | 'new_arrival';
  onChangeSort: (sort: 'post_updated_at' | 'new_arrival') => void;
}

const Header: React.FC<Props> = props => {
  const {title, totalCount, sort, onChangeSort} = props;
  return (
    <>
      <SearchResultHeader title={title} />
      <TotalCountWithSort
        style={{paddingHorizontal: 16}}
        totalCount={totalCount}
        sort={sort}
        onPress={onChangeSort}
      />
      <ListItemNormalSeparator />
    </>
  );
};

export default React.memo(Header);
